import 'datatables.net-bs/css/dataTables.bootstrap.css';
import 'datatables.net-bs';




// WEBPACK FOOTER //
// ./webpack/assets/javascripts/bundle_datatables.js